// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jrzt","delete":"styles_delete__1PzUc","update":"styles_update__20EEa","add":"styles_add__1iBjD"};